import React from 'react';
import Container from 'react-bootstrap/Container';

const Home = () => {

    //const { user: currentUser } = useSelector(state => state.auth);
    //console.log(currentUser);
   
    return (
        <Container></Container>
    )
}

export default Home;